import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing);


// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import router from './router'

Vue.config.productionTip = false


Vue.use(VueRouter)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


